import React, { useState, useEffect, Fragment } from 'react';
import { Tooltip } from 'reactstrap';
import CasOrgsTabel from '../Common/Tabel/CasOrgsTabel';
import { useSelector } from 'react-redux';
import { Loading } from '../Common';
import './CasOrgsInstitutionDetails.scss';

const CasOrgsInstitutionDetails = () => {
  const userCasOrgsLoading = useSelector((state) => state.AppSession.institutionDetailsLoading);
  const userCasOrgs = useSelector((state) => state.AppSession.institutionDetails.casOrgs);
  const institutionName = useSelector((state) => state.AppSession.institutionDetails.institutionName);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [orgsCount, setOrgsCount] = useState(null);

  const tpToggle = () => setTooltipOpen(!tooltipOpen);

  const renderDropdown = () => {
    return orgsCount ? (
      <Fragment>
        <div tabIndex="0" role="button" aria-haspopup="false" aria-expanded="false" className="tp-header">
          <div>{institutionName}</div>
          <label htmlFor={'tooltipInstitution'}>
            {`${orgsCount} Organizations`}
            <span
              className="mLeft-5"
              aria-describedby={tooltipOpen ? 'tpLabel' : ''}
              onClick={(e) => e.preventDefault()}
              id="tooltipInstitution">
              <i className="far fa-question-circle"></i>
            </span>
          </label>
        </div>
        <Tooltip
        className={'tp-container'}
        placement="bottom"
        isOpen={tooltipOpen}
        autohide={false}
        target="tooltipInstitution"
        toggle={tpToggle}>
        <div id="tpLabel" className="tp-wrapper" role="none">
          <h3>The following organizations are being used to build dashboards for this user.</h3>
          <CasOrgsTabel casOrganizations={[...userCasOrgs]} />
        </div>
      </Tooltip>
      </Fragment>) : null;
  };

  useEffect(() => {
    const orgsCount = (userCasOrgs || []).map((org) => org.clients.length).reduce((total, num) => total + num, 0);
    setOrgsCount(orgsCount);
  }, [userCasOrgs]);

  return (
    <Fragment>
      <nav id="navDDM" aria-label="cas institution" className="ddm-institution">
        {renderDropdown()}
        <Loading show={userCasOrgsLoading} classNames={['app-ddm-loading']} />
      </nav>
    </Fragment>
  );
};

export default CasOrgsInstitutionDetails;
